import React from 'react';
import { Section } from './ui/Section';
import { Check, X } from 'lucide-react';
export function WhoItsFor() {
  return <Section data-id="element-222">
      <div className="grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-223">
        {/* For You */}
        <div className="bg-sage-light/40 p-6 rounded-2xl" data-id="element-224">
          <h3 className="text-xl font-bold mb-6 text-sage-dark" data-id="element-225">
            Es para vos si:
          </h3>
          <ul className="space-y-4" data-id="element-226">
            {['querés comer más ordenada sin vivir midiendo todo', 'querés bajar la ansiedad de "¿qué como?"', 'querés algo que funcione incluso cuando estás cansada'].map((item, idx) => <li key={idx} className="flex gap-3" data-id="element-227">
                <Check className="w-5 h-5 text-sage mt-0.5 flex-shrink-0" data-id="element-228" />
                <span className="text-brown-body" data-id="element-229">{item}</span>
              </li>)}
          </ul>
        </div>

        {/* Not For You */}
        <div className="bg-amber-light p-6 rounded-2xl border border-amber/10" data-id="element-230">
          <h3 className="text-xl font-bold mb-6 text-amber" data-id="element-231">
            No es para vos si:
          </h3>
          <ul className="space-y-4" data-id="element-232">
            {['buscás promesas clínicas o "curas"', 'querés un plan médico personalizado', 'no querés cocinar nada nunca'].map((item, idx) => <li key={idx} className="flex gap-3" data-id="element-233">
                <X className="w-5 h-5 text-amber mt-0.5 flex-shrink-0" data-id="element-234" />
                <span className="text-brown-body" data-id="element-235">{item}</span>
              </li>)}
          </ul>
        </div>
      </div>
    </Section>;
}